import React from 'react';
import styled from 'styled-components';
import { animated } from 'react-spring';

import { DirectionType, ComponentStageType } from '../../types';

import { TestHeader } from '../TestHeader';

import { FullHeightContainer } from '../Containers';
import { ArrowPad } from '../ArrowPad';
import { LandholtDisplay } from '../LandholtDisplay';
import { ButtonBar } from '../ButtonBar';

import { animationDelay, breakpoints } from '../../constants';
import { createEnterExitAnimation } from '../../transitions';

const BottomText = styled(animated.p)`
    padding: 25px 0;
    text-align: center;
    cursor: pointer;
`;

interface IProps {
    className?: string;
    currentAnswer: boolean | null;
    currentTestSizePx: number;
    openingDirection?: DirectionType;
    componentStage: ComponentStageType;
    onArrowClick(direction: DirectionType): void;
    onPassQuestionClick(): void;
    onAnimationExit(): void;
}

export const BaseVisualAcuityTestView: React.FC<IProps> = ({
    className,
    componentStage,
    currentAnswer,
    currentTestSizePx,
    openingDirection,
    onArrowClick,
    onPassQuestionClick,
    onAnimationExit,
}) => {
    const firstAnimation = createEnterExitAnimation({
        stage: componentStage,
    });
    const secondAnimation = createEnterExitAnimation({
        stage: componentStage,
        delay: animationDelay.second,
    });
    const thirdAnimation = createEnterExitAnimation({
        stage: componentStage,
        delay: animationDelay.third,
    });
    const fourthAnimation = createEnterExitAnimation({
        stage: componentStage,
        delay: animationDelay.fourth,
        onRest: onAnimationExit,
    });

    return (
        <>
            <FullHeightContainer className={className}>
                <TestHeader style={firstAnimation}>
                    Geef aan <strong>waar de opening van de cirkel zit.</strong>
                </TestHeader>
                <LandholtDisplay
                    currentTestSizePx={currentTestSizePx}
                    currentAnswer={currentAnswer}
                    direction={openingDirection}
                    style={secondAnimation}
                />
                <ArrowPad onArrowClick={onArrowClick} style={thirdAnimation} />
                <BottomText
                    onClick={onPassQuestionClick}
                    style={fourthAnimation}
                >
                    Ik weet het niet
                </BottomText>
            </FullHeightContainer>
            <ButtonBar hideOnMobile />
        </>
    );
};

export const VisualAcuityTestView = styled(BaseVisualAcuityTestView)`
    padding-top: 80px;

    @media (${breakpoints.mediumMin}) {
        padding-top: 120px;

        ${BottomText} {
            padding-bottom: 0;
        }
    }
`;
